<template>
  <div>
    <v-form v-model="documentForm" ref="form">
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-file-input
              v-model="file"
              rounded
              filled
              background-color="transparent"
              color="secondary"
              dense
              :rules="nameRules"
            >
              <template v-slot:label>Adjuntar documento<span class="red--text">*</span> </template>
            </v-file-input>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="documento.fk_idTipoDocumento"
              label="Tipo de documento"
              background-color="transparent"
              color="secondary"
              rounded
              filled
              dense
              :items="tipoDocumento"
              item-value="id"
              item-text="title"
              :rules="nameRules"
            >
              <template v-slot:label>Tipo de documento <span class="red--text">*</span> </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-textarea
              no-resize
              rows="3"
              color="secondary"
              background-color="transparent"
              label="Observaciones"
              v-model="documento.observaciones"
              rounded
              filled
              dense
            ></v-textarea>
            <v-checkbox
              v-model="bajoProtesta"
              label="Declaro bajo protesta de decir verdad que la documentación proporcionada es auténtica. De no ser así, asumo plenamente las responsabilidades que fijen las leyes."
              color="secondary"
              :rules="nameRules"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <div class="d-flex justify-center pb-4">
      <v-btn
        color="secondary"
        class="primary--text px-8"
        :disabled="!documentForm || loading"
        :loading="loading"
        v-on:click="triggerSaveDocument()"
      >
        Editar registro
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {
      documentForm: false,
      loading: false,
      fecha: null,
      nombre: '',
      file: null,
      fileBajoProtesta: null,
      bajoProtesta: false,
      // estatusDocumentoElegido: null,

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('tipoDocumento', {
      tipoDocumento: 'getTipoDocumento',
    }),

    getMaxDay: function () {
      return moment().format(this.VUETIFY_DATE_FORMAT)
    },
    ...mapGetters('documento', {
      documento: 'getSelectedDocumento',
    }),
  },

  methods: {
    ...mapActions('documento', ['saveDocumentoPersonal', 'fetchDocumentoByPersonal', 'updateDocumentoPersonal']),

    triggerSaveDocument: async function () {
      this.loading = true
      await this.updateDocumentoPersonal({
        fk_idPersonal: this.documento.fk_idPersonal,
        fk_idTipoDocumento: this.documento.fk_idTipoDocumento,
        observaciones: this.documento.observaciones,
        nombre: this.file.name,
        file: this.file,
        id: this.documento.iddocumentosPersonal,
      })

      this.resetForm()
      await this.fetchDocumentoByPersonal(this.documento.fk_idPersonal)

      this.closeDialog()
    },

    closeDialog() {
      this.loading = false
      this.$emit('close')
    },

    resetForm() {
      this.observaciones = ''
      this.fecha = null
      this.nombre = ''
      this.file = null
      this.fileBajoProtesta = null
      this.bajoProtesta = false
      this.tipoDocumentoElegido = null

      this.$refs.form.resetValidation()
    },
  },
}
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
  caret-color: var(--v-secondary-base) !important;
}

::v-deep input::placeholder,
::v-deep textarea::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-input--checkbox .v-input__slot {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .v-input--checkbox .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--checkbox.v-input--is-label-active .v-icon {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}
</style>
